var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbbBusinessScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c8586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#005f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00386a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.61441,72.64996l3.6344-5.0074c.84384-1.15387,1.29948-2.5459,1.30121-3.97541-.00314-.36366-.03313-.72659-.08974-1.08584-.27483-1.77593-1.24305-3.37027-2.69215-4.43307l-6.87396-4.98945c-.3825-.25606-.64227-.65872-.71791-1.11276-.00898-.08974-.00898-.17948,0-.26922.00234-.35741.11517-.70535.32306-.9961l-1.03199-.7538-3.65236,5.01637c-2.20192,3.03588-1.52707,7.28177,1.5076,9.48534l6.88293,4.99843c.76409.55057.9333,1.61822.3769,2.37807l1.03199.74483"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4798,27.35004l-5.51891,7.60981c-1.21901,1.67358-1.87568,3.69073-1.87553,5.7612-.00269.52587.03948,1.05173.12563,1.57042.40124,2.58235,1.82005,4.89641,3.93951,6.42527l8.65078,6.28169c1.13321.81855,1.89243,2.05591,2.10885,3.43698.04604.27886.07004.56091.07179.84354-.00439,1.10461-.35945,2.17928-1.01404,3.06905l.83457.60125,6.81114-9.41355c3.18033-4.40885,2.1968-10.55862-2.19859-13.75689l-10.43657-7.58289c-.65259-.47264-1.08886-1.18683-1.21147-1.98322-.13309-.79558.0611-1.61117.53843-2.26141l-.82559-.60125"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbbBusinessScraper);
export default __webpack_public_path__ + "static/media/bbb-business-scraper.b132d356066b310b9860d8c113bac857.svg";
export { ForwardRef as ReactComponent };